import * as React from 'react';
import { useEffect, useState } from 'react';

import Retracked from 'js/app/retracked';
import thirdParty from 'js/lib/thirdParty';

import { useTracker } from '@coursera/event-pulse/react';

import type { ChiliPiperType } from 'bundles/expression-of-interest/types';
import {
  CHILI_PIPER_ACCOUNT,
  CHILI_PIPER_ROUTERS,
  CHILI_PIPER_SCRIPT_URL,
} from 'bundles/expression-of-interest/utils/chiliPiperUtils';

declare global {
  interface Window {
    ChiliPiper: ChiliPiperType;
  }
}

const TRACKING_CONTEXT = {
  namespace: {
    app: 'xddp',
    page: 'call_scheduler',
  },
};

const ChiliPiperCallScheduler = () => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const track = useTracker();

  useEffect(() => {
    const loadChiliPiper = async () => {
      await thirdParty
        .loadScript({
          url: CHILI_PIPER_SCRIPT_URL,
        })
        .then(() => {
          Retracked.trackComponent(TRACKING_CONTEXT, {}, 'chilipiper_script_load', 'success');
          track('load_success_script', {
            script: {
              name: 'chilipiper',
              url: CHILI_PIPER_SCRIPT_URL,
            },
          });
          setScriptLoaded(true);
        })
        .catch((error) => {
          Retracked.trackComponent(TRACKING_CONTEXT, { error }, 'chilipiper_script_load', 'fail');
          track('load_failure_script', {
            script: {
              name: 'chilipiper',
              url: CHILI_PIPER_SCRIPT_URL,
            },
          });
        });
    };

    if (scriptLoaded) {
      // If email is not present, this widget will not load.
      window?.ChiliPiper.getQuery(CHILI_PIPER_ACCOUNT, CHILI_PIPER_ROUTERS.drift, {
        queryVariable: 'email',
        map: true,
      });
    } else {
      loadChiliPiper();
    }
  }, [scriptLoaded, track]);

  return <div data-testid="call_scheduler_page" />;
};

export default Retracked.createTrackedContainer(() => ({
  TRACKING_CONTEXT,
}))(ChiliPiperCallScheduler);
